import type { ChordName } from '../../../core/theory';
import { defineSong } from '../types';

// The recording is in 4/4 at 76 BPM and the chord changes every two beats, so one bar here is two beats.
// Intro, choruses, interludes and ending ride the same i–VI–III–VII loop; the riff phrases end on VI (C).
const loop: ChordName[] = ['Em', 'C', 'G', 'D'];
const riffEnd: ChordName[] = ['Em', 'C', 'G', 'C'];
const verse: ChordName[] = ['Em', 'Am', 'D', 'D', 'Em', 'Am', 'G', 'D', 'Em', 'Am', 'Bm', 'C', 'Em', 'Am', 'D', 'D'];
const toFive: ChordName[] = ['Em', 'Am', 'D', 'G', 'Em', 'Am', 'B7', 'B7'];
const preChorus: ChordName[] = [...toFive, ...toFive, 'B7', 'B7'];
const chorus: ChordName[] = [...loop, ...loop, ...loop, ...loop];

export default defineSong({
  id: 'ask-durdukca',
  title: 'Aşk Durdukça',
  level: 3,
  key: 'Em',
  bpm: 76,
  beats: 2,
  pattern: 'D-DU',
  style: 'Türk rock',
  desc: "{{pc:E}} minörde giriş ve nakarat i–VI–III–VII döngüsünde dönüyor; akorlar iki vuruşta bir değişiyor, bası takip et. {{pc:B}} üzerine kurulan akor kıtada minör (v), köprünün sonundaysa majör 7'li (V7): dört ölçü boyunca seni nakarata hazırlıyor.",
  sections: [
    { name: 'Giriş', bars: [...loop, ...loop, ...loop, ...riffEnd, 'C'] },
    { name: 'Kıta', bars: [...verse] },
    { name: 'Kıta', bars: [...verse] },
    { name: 'Köprü', bars: [...preChorus] },
    { name: 'Nakarat', bars: [...chorus] },
    { name: 'Ara', bars: [...loop, ...loop, ...loop, ...riffEnd, 'D'] },
    { name: 'Köprü', bars: [...preChorus] },
    { name: 'Nakarat', bars: [...chorus] },
    { name: 'Nakarat', bars: [...chorus] },
    { name: 'Ara', bars: [...loop, ...loop] },
    { name: 'Son', bars: [...loop, ...riffEnd] },
  ],
  cover: {
    artist: 'Yüksek Sadakat',
    references: [
      'https://www.songsterr.com/a/wsa/yuksek-sadakat-ask-durdukca-sona-kadar-tab-s386887',
      'https://www.songsterr.com/a/wsa/yuksek-sadakat-ask-durdukca-ai-tab-s3484455',
      'https://tabs.ultimate-guitar.com/tab/3188579',
      'https://www.repertuarim.com/akor/yuksek-sadakat-ask-durdukca-akor-934.html',
      'https://akormatik.com/pages/song/yuksek-sadakat-ask-durdukca',
    ],
    year: 2008,
    listen: 'https://open.spotify.com/track/4scldqQmZGfzMMnZHEQDyX',
  },
});
